/* eslint-disable no-shadow */

const state = {
    loading: false,
};

const mutations = {
    SET_LOADING(state, payload) {
        state.loading = payload;
    },
};

const actions = {
    showLoading({ commit }) {
        commit('SET_LOADING', true);
    },
    hideLoading({ commit }) {
        commit('SET_LOADING', false);
    },
};

const getters = {
    isLoading: state => state.loading,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
